<template>
  <div class="content-header-left col-md-9 col-12 mb-2">
    <div class="row breadcrumbs-top">
      <div class="col-12 d-flex">
        <h2 class="content-header-title float-start mb-0">Knowledge Center</h2>
        <div class="breadcrumb-wrapper">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'knowledge-base-index' }"> Home </router-link>
            </li>
            <li class="breadcrumb-item">
              {{ searchTitle }}
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
  <KnowledgeBaseSearch
    :url="`/knowledge/center/${categorySlug}/search/video`"
    :method="showResults"
    :pagination="false"
    :searchTitle="searchTitle"
  />
  <section id="knowledge-base-content">
    <div
      class="row kb-search-content-info match-height"
      style="position: relative; min-height: 300px; min-width: 100%"
    >
      <!-- sales card -->
      <div
        class="col-md-3 col-sm-6 col-12 kb-search-content mb-1"
        v-for="(videoList, index) in videoLists"
        :key="index"
        style="position: relative"
        v-if="videoLists.length > 0"
      >
        <div :class="objectClass">
          <div style="position: relative">
            <div style="position: relative" :class="userClass">
              <img
                :src="videoList.image_url"
                class="card-img-top"
                :alt="videoList.title"
                v-if="videoList.image_url"
              />
              <img
                src="https://creditrepair-development.nyc3.digitaloceanspaces.com/7/635655bc62bc7-dynamically-retrieve-seo-data-from-your-model.jpg"
                class="card-img-top"
                :alt="videoList.video_title"
                v-else
              />
              <div class="knowledgebase_video_background"></div>
              <vue-feather
                width="28px"
                height="28px"
                type="play-circle"
                class="knowledgebase_icon"
                @click="
                  showVideoPlayer(
                    videoList.video_url,
                    videoList.video_media_url,
                    videoList.video_type,
                    videoList.video_title,
                    videoList.slug
                  )
                "
              ></vue-feather>
            </div>
            <!-- <div class="card-body text-justify">
                            <h5>{{ videoList.video_title }}</h5>
                        </div> -->
          </div>
          <hr v-if="can == 'can_edit'" />
          <!-- dropdown -->
          <div class="editDeleteSection" v-if="can == 'can_edit'">
            <div class="allEditDelete d-flex align-items-center">
              <div class="mr-1" v-on:click="actionTrigger(1, videoList.uuid)">
                <b-link class="mr-50">
                  <vue-feather type="edit-3"></vue-feather>
                </b-link>
              </div>
              <div
                class="mr-1"
                @click="actionTrigger(0, videoList.uuid)"
                v-if="videoList.deleted_at == null"
              >
                <div class="d-flex align-items-center">
                  <b-link class="mr-50">
                    <vue-feather type="trash-2"></vue-feather>
                  </b-link>
                </div>
              </div>
            </div>
            <div class="dropdown b-dropdown show btn-group" id="__BVID__935"></div>
          </div>
        </div>
      </div>
      <!-- end -->
      <div class="col-12 text-center no-result" v-else>
        <h4 class="mt-4">No Result found!!</h4>
      </div>
      <CreditFixrrLoader styleType="dynamic" :toggle="ContentisLoading" />
      <b-col cols="12">
        <!-- pagination -->
        <div v-if="containPagination == true">
          <div
            class="my-2 d-flex justify-content-center"
            v-if="containPagination == true"
          >
            <pagination
              v-model="currentPage"
              :records="rows"
              :per-page="perPage"
              @paginate="getList"
            />
          </div>
        </div>
      </b-col>
    </div>
  </section>

  <div
    class="modal fade text-left show"
    tabindex="-1"
    aria-labelledby="myModalLabel17"
    style="padding-right: 15px; display: block; background: #000000b5"
    aria-modal="true"
    role="dialog"
    v-if="isPlayerActive == true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="pause(videoId)"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div v-if="videoType == 1">
            <iframe
              v-if="videoUrl"
              style="margin: auto; height: 66vh; width: 100%"
              width="560"
              height="315"
              :src="`https://www.youtube.com/embed/${videoUrl}`"
              :title="videoTitle"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <div v-else>
            <vue3-video-player
              :src="videoUrl"
              v-if="videoUrl"
              ref="videocontainer"
              :title="videoTitle"
              :view-core="viewCore.bind(null, videoId)"
            ></vue3-video-player>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- sweet alert -->
  <div
    id="sweetAlertDelete"
    class="swal2-container swal2-center swal2-backdrop-show"
    style="overflow-y: auto"
    v-if="showSweetDialog && can == 'can_edit'"
  >
    <div
      aria-labelledby="swal2-title"
      aria-describedby="swal2-html-container"
      class="swal2-popup swal2-modal swal2-icon-warning swal2-show"
      tabindex="-1"
      role="dialog"
      aria-live="assertive"
      aria-modal="true"
      style="display: grid"
    >
      <button
        type="button"
        class="swal2-close"
        style="display: none"
        aria-label="Close this dialog"
      >
        ×
      </button>
      <ul class="swal2-progress-steps" style="display: none"></ul>
      <div class="swal2-icon swal2-warning swal2-icon-show" style="display: flex">
        <div class="swal2-icon-content">!</div>
      </div>
      <img class="swal2-image" style="display: none" />
      <h2 class="swal2-title" id="swal2-title" style="display: block">Are you sure ?</h2>
      <div class="swal2-html-container" style="display: block" v-if="actionType == 0">
        You won't be able to revert this!
      </div>
      <input class="swal2-input" style="display: none" />
      <input type="file" class="swal2-file" style="display: none" />
      <div class="swal2-range" style="display: none">
        <input type="range" />
        <output></output>
      </div>
      <select class="swal2-select" style="display: none"></select>
      <div class="swal2-radio" style="display: none"></div>
      <label for="swal2-checkbox" class="swal2-checkbox" style="display: none">
        <input type="checkbox" />
        <span class="swal2-label"></span>
      </label>
      <textarea class="swal2-textarea" style="display: none"></textarea>
      <div
        class="swal2-validation-message"
        id="swal2-validation-message"
        style="display: none"
      ></div>
      <div class="swal2-actions">
        <div class="swal2-loader"></div>
        <button
          type="button"
          class="swal2-confirm btn btn-primary"
          style="display: inline-block"
          aria-label=""
          v-on:click="openVideoEditor"
          v-if="actionType == 1"
        >
          Yes, Edit it!
        </button>
        <button
          type="button"
          class="swal2-confirm btn btn-primary"
          style="display: inline-block"
          aria-label=""
          v-on:click="deleteVideo"
          v-else
        >
          Yes, delete it!
        </button>
        <button
          type="button"
          class="swal2-deny mr-10"
          style="display: none"
          aria-label=""
        >
          No</button
        >&nbsp;&nbsp;&nbsp;
        <button
          id="closeDeleter"
          type="button"
          class="swal2-cancel btn btn-outline-danger ms-1"
          style="display: inline-block"
          aria-label="sweetAlertDelete"
          v-on:click="closeSweetBox"
        >
          Cancel
        </button>
      </div>
      <div class="swal2-footer" style="display: none"></div>
      <div class="swal2-timer-progress-bar-container">
        <div class="swal2-timer-progress-bar" style="display: none"></div>
      </div>
    </div>
  </div>
  <a
    type="button"
    href="#"
    class="btn btn-outline-secondary d-none d-sm-block waves-effect"
    data-toggle="modal"
    data-target="#editCategoryData"
    ref="clicker"
    hidden
    style="display: none !important"
    v-if="can == 'can_edit'"
    >clickers</a
  >
  <div v-if="can == 'can_edit'">
    <div
      class="modal fade"
      id="editCategoryData"
      tabindex="-1"
      aria-labelledby="editCategoryDataTitle"
      style="display: none"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg two-factor-auth-sms">
        <div class="modal-content" style="position: relative">
          <div class="modal-header bg-transparent">
            <button
              id="editCategoryDataClose"
              type="button"
              class="btn-close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true" ref="closeEdit">×</span>
            </button>
          </div>
          <div class="modal-body pb-5 px-sm-5 mx-50">
            <form action="javascript:;" class="mt-2" v-on:submit.prevent="editCategory">
              <div class="row">
                <div class="col-md-12 col-12">
                  <div class="form-group mb-2">
                    <label for="blog-edit-title">Video Title</label>
                    <b-form-input
                      id="blog-edit-title"
                      v-model="videoEditTitle"
                      placeholder="Category Title"
                    />
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group mb-2">
                    <label>Video Description</label>
                    <div id="blog-editor-wrapper">
                      <b-form-textarea
                        id="textarea-state"
                        v-model="VideoEditDecription"
                        placeholder="Enter at least 10 characters"
                        rows="3"
                      >
                      </b-form-textarea>
                    </div>
                  </div>
                </div>
                <template v-if="editorVideoType == 1">
                  <div class="col-lg-3 col-md-6 col-sm-12">
                    <div class="form-group mb-2">
                      <label>YouTube Video ID</label>
                      <div id="blog-editor-wrapper">
                        <b-form-input
                          id="textarea-state"
                          v-model="VideoLink"
                          placeholder="Enter at least 10 characters"
                          rows="3"
                        >
                        </b-form-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-9 col-md-6 col-sm-12">
                    <div class="form-group mb-2">
                      <label for="blog-edit-status">Video Publish Status</label>
                      <v-select
                        id="video-edit-input"
                        class="v-custom-style"
                        :height="28"
                        v-model="VideoPublishStatus"
                        :options="statusOption"
                      />
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="col-lg-12 col-md-6 col-sm-12">
                    <div class="form-group mb-2">
                      <label for="blog-edit-status">Video Publish Status</label>
                      <v-select
                        id="video-edit-input"
                        class="v-custom-style"
                        :height="28"
                        v-model="VideoPublishStatus"
                        :options="statusOption"
                      />
                    </div>
                  </div>
                </template>

                <div class="col-lg-12 mb-2">
                  <div class="border rounded p-2">
                    <h4 class="mb-1">Featured Image</h4>
                    <div class="media flex-column flex-md-row">
                      <img
                        :src="file"
                        id="blog-feature-image preview"
                        class="rounded mr-2 mb-1 mb-md-0"
                        width="170"
                        height="110"
                        alt="Blog Featured Image"
                        v-if="file"
                      />
                      <img
                        src="/assets/images/slider/03.jpg"
                        id="blog-feature-image preview"
                        class="rounded mr-2 mb-1 mb-md-0"
                        width="170"
                        height="110"
                        alt="Blog Featured Image"
                        v-else
                      />

                      <div class="media-body">
                        <small class="text-muted"
                          >Required image resolution 800x400, image size 10mb.</small
                        >
                        <p class="my-50">
                          <a href="javascript:void(0);" id="blog-image-text"
                            >C:\fakepath\banner.jpg</a
                          >
                        </p>
                        <div class="d-inline-block">
                          <div class="form-group mb-0">
                            <div class="custom-file">
                              <input
                                type="file"
                                class="custom-file-input"
                                id="blogCustomFile"
                                accept="image/*"
                                data-toggle="modal"
                                data-target="#larger"
                                @change="selectedImg"
                                enctype="multipart/form-data"
                              />
                              <label class="custom-file-label" for="blogCustomFile"
                                >Choose file</label
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 mt-50 d-flex justify-content-end">
                  <button type="submit" class="btn btn-primary mr-1">
                    Update Video Details
                  </button>
                </div>
              </div>
            </form>
          </div>
          <CreditFixrrLoader styleType="dynamic" :toggle="EditisLoading" />
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade text-left show"
    id="larger"
    tabindex="-1"
    aria-labelledby="myModalLabel17"
    style="padding-right: 15px"
    aria-modal="true"
    role="dialog"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <cropper
            v-if="img"
            class="cropper"
            :src="img"
            :stencil-props="{
              aspectRatio: 4 / 2,
            }"
            @change="change"
          />
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary waves-effect waves-float waves-light"
            data-dismiss="modal"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  </div>
  <CreditFixrrLoader styleType="full" :toggle="PageisLoading" />
</template>
<script>
import { BBadge, BLink, BFormInput, BFormTextarea, BRow, BCol } from "bootstrap-vue-3";
import { ref } from "vue";
import KnowledgeBaseSearch from "./KnowledgeBaseSearch.vue";
import EditCategoryKnowledgeBase from "../models/EditCategoryKnowledgeBase.vue";
import CreditFixrrLoader from "../loader/CreditFixrrLoader.vue";
import axios from "axios";
import vSelect from "vue-select";
import { Cropper } from "vue-advanced-cropper";
import "vue-select/dist/vue-select.css";
import "vue-advanced-cropper/dist/style.css";

export default {
  components: {
    KnowledgeBaseSearch,
    BBadge,
    EditCategoryKnowledgeBase,
    vSelect,
    Cropper,
    CreditFixrrLoader,
    BRow,
    BCol,
    BLink,
    BFormInput,
    BFormTextarea,
  },
  props: {},
  data() {
    return {
      videoLists: {},
      players: {},
      currentpageUrl: "",
      categorySlug: "",
      actionType: "",
      showSweetDialog: "",
      videoUuid: "",
      PageisLoading: "",
      isPlayerActive: false,
      EditisLoading: false,
      statusOption: ref(["Publish", "Draft"]),
      editorVideoType: "",
      objectClass: "",
      userClass: "",
      can: false,
    };
  },
  setup(props) {
    let prevDataResult = ref(),
      clicker = ref(),
      ContentisLoading = ref(),
      currentPage = ref(),
      perPage = ref(),
      prevPage = ref(),
      nextPage = ref(),
      rows = ref(),
      containPagination = ref(false),
      searchTitle = ref(),
      videoUrl = ref(),
      videoplayerclicker = ref(),
      videoType = ref(),
      videocontainer = ref(),
      videoTitle = ref(),
      videoId = ref(),
      viewCore = ref(),
      youtube = ref(),
      player = ref(),
      videoEditTitle = ref(null),
      VideoEditDecription = ref(null),
      VideoLink = ref(null),
      VideoPublishStatus = ref(null),
      img = ref(null),
      file = ref(null),
      closeEdit = ref();
    return {
      prevDataResult,
      ContentisLoading,
      currentPage,
      perPage,
      prevPage,
      nextPage,
      rows,
      containPagination,
      searchTitle,
      videoUrl,
      videoplayerclicker,
      videoType,
      videocontainer,
      videoTitle,
      videoId,
      viewCore,
      youtube,
      player,
      youtube,
      videoEditTitle,
      VideoEditDecription,
      clicker,
      img,
      file,
      closeEdit,
      VideoLink,
      VideoPublishStatus,
    };
  },
  created() {
    this.currentpageUrl = window.location.href;
    this.SetSlugCategoryFromUrl();
  },
  mounted() {
    this.getList(1);
  },
  computed() {},
  methods: {
    actionTrigger(type, id) {
      this.actionType = type;
      this.showSweetDialog = true;
      this.videoUuid = id;
    },
    closeSweetBox() {
      this.actionType = null;
      this.showSweetDialog = false;
      this.videoUuid = null;
    },
    openVideoEditor() {
      this.showSweetDialog = false;
      this.PageisLoading = true;
      axios
        .post(`/admin/knowledge/center/edit/video/${this.videoUuid}/fetch`)
        .then((data) => {
          if (data) {
            this.videoEditTitle = data.data.data.title;
            this.VideoEditDecription = data.data.data.description;
            this.VideoLink = data.data.data.video_url;
            this.VideoPublishStatus =
              data.data.data.published == true ? "Publish" : "Draft";
            this.editorVideoType = data.data.data.video_type;
            this.file = data.data.data.image_url;
            this.toEditData = data.data.data;
            this.clicker.click();
            this.PageisLoading = false;
          }
        });
    },
    deleteVideo() {
      this.videoUuid;
      this.PageisLoading = true;
      axios
        .post(`/admin/knowledge/center/delete/video/${this.videoUuid}`)
        .then(({ data }) => {
          this.getList();
          this.PageisLoading = false;
          this.closeSweetBox();
        })
        .catch();
    },
    selectedImg(e) {
      e.preventDefault();
      const file = e.target.files[0];
      this.img = URL.createObjectURL(file);
    },
    converter(canvas) {
      this.file = canvas.toDataURL();
    },
    change({ coordinates, canvas }) {
      this.converter(canvas);
    },
    clearFields() {
      this.videoType = null;
      this.videoTitle = null;
      this.videoId = null;
    },
    editCategory() {
      if (this.uuid != "") {
        var videTitle = this.videoEditTitle,
          vidDecription = this.VideoEditDecription,
          file = this.file;
        if (this.file == this.toEditData.image_url) {
          file = "";
        }
        const params = {
          video_title: videTitle,
          video_decription: vidDecription,
          image: file,
          video_link: this.VideoLink,
          video_publish_status: this.VideoPublishStatus,
        };
        if (videTitle != "" && vidDecription != "") {
          this.EditisLoading = true;
          var $this = this;

          axios
            .put(`/admin/knowledge/center/edit/video/${this.videoUuid}`, params)
            .then(({ data }) => {
              if (data.error == false) {
                $this.EditisLoading = false;
                $this.clearFields();
                $this.getList();
                setTimeout(() => {
                  $this.closeEdit.click();
                }, 1000);
                return toastr.success(data.message, "Success");
              }
            })
            .catch((error) => {
              return toastr.error(error.message, "error!");
            });
        } else {
          toastr.error("All fields are required!", "error!");
        }
      }
    },
    async getList(page) {
      if (typeof page == null || typeof page == undefined) {
        page = 1;
      }
      let $this = this;
      let url = window.location.href;
      await axios
        .post(`${url}?page=${+page}`)
        .then(({ data }) => {
          let dataCurrent = data.data.data;
          $this.videoLists = dataCurrent.data;
          $this.searchTitle = data.data.cat_title;
          $this.prevDataResult = dataCurrent.data;
          $this.can = data.data.will_edit;
          $this.ContentisLoading = false;
          $this.containPagination = true;
          $this.currentPage = dataCurrent.current_page;
          $this.perPage = dataCurrent.per_page;
          $this.prevPage = dataCurrent.prev_page_url;
          $this.nextPage = dataCurrent.next_page_url;
          $this.rows = dataCurrent.total;
          this.PageisLoading = false;
          if (this.can != "can_edit") {
            this.objectClass = { card: false };
            this.userClass = { userclass: true };
          } else {
            this.objectClass = { card: true };
            this.userClass = { userclass: false };
          }
        })
        .catch();
    },
    showVideoPlayer(videoYTSrc, videoMediaUrl, videoType, videoTitle, videoId) {
      if (videoType == 1) {
        this.videoUrl = videoYTSrc;
      } else {
        this.videoUrl = videoMediaUrl;
      }

      this.videoType = videoType;
      this.videoTitle = videoTitle;
      this.videoId = videoId;
      setTimeout(() => {
        this.isPlayerActive = true;
      }, 1000);
    },
    pause(id) {
      if (this.videoType == 0) {
        this.players && this.players[id] && this.players[id].pause();
        this.clearFields();
        this.videoUrl = null;
      } else {
        this.clearFields();
        this.videoUrl = null;
      }
      this.isPlayerActive = false;
    },
    showResults(result, pagination) {
      if (result.data == undefined) {
        this.getList();
        this.containPagination = true;
      } else {
        if (result.data.data.length <= 0) {
          toastr.error("No Result Found", "Search");
          this.getList();
          this.containPagination = true;
        } else {
          let $this = this;
          let dataCurrent = result.data;
          $this.videoLists = dataCurrent.data;
          $this.prevDataResult = dataCurrent.data;
          $this.can = result.data.will_edit;
          $this.ContentisLoading = false;
          $this.containPagination = pagination;
        }
      }
    },
    SetSlugCategoryFromUrl() {
      let url = window.location.href;
      let getData = url.split("knowledge/")[1];
      let splitData = getData.split("/");
      let categorySlug = splitData[1];
      this.categorySlug = categorySlug;
    },
    viewCore(id, player) {
      this.players[id] = player;
    },
  },
};
</script>
<style>
.knowledgebase_icon {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  color: #ffffff;
  height: 50px;
  width: 50px;
  cursor: pointer;
  transition: color ease-in-out 0.5s;
  -webkit-transition: color ease-in-out 0.5s;
  -moz-transition: color ease-in-out 0.5s;
  -o-transition: color ease-in-out 0.5s;
}
.knowledgebase_video_background {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0px;
  left: 0px;
}
.knowledgebase_icon:hover {
  color: #4dc36a;
}
.userclass {
  border-bottom-left-radius: 5px;
  overflow: hidden;
  border-bottom-right-radius: 5px;
}
</style>
